import React from 'react';
import styled from 'styled-components';
import { MdPhonelinkSetup, MdCode } from 'react-icons/md';
import { IoInfinite } from 'react-icons/io5';
import Bounce from 'react-reveal/Bounce';
import Flip from 'react-reveal/Flip';
import SectionTitle from './SectionTitle';
import ServicesSectionItem from './ServicesSectionItem';
import HorizontalLine from './HorizontalLine';

const ServicesItemStyles = styled.div`
  padding: 10rem 0;
  .services__allItems {
    display: flex;
    gap: 10rem;
    justify-content: space-between;
    margin-top: 5rem;
  }

  @media only screen and (max-width: 768px) {
    .services__allItems {
      flex-direction: column;
      max-width: 350px;
      margin: 0 auto;
      margin-top: 5rem;
      gap: 5rem;
    }
  }
`;
export default function ServicesSection() {
  return (
    <ServicesItemStyles>
      <HorizontalLine />
      <div className="container">
        <Bounce top>
          <SectionTitle heading="Services" subheading="what i will do for u" />
        </Bounce>
        <div className="services__allItems">
          <Flip left>
            <ServicesSectionItem
              icon={<MdPhonelinkSetup />}
              title="Problem Solving"
              desc=" I love solving problems and learn new algorithms. I do competitve progemming and i am very much active on various platforms."
            />
          </Flip>
          <Flip top>
            <ServicesSectionItem
              icon={<MdCode />}
              title="Web Development"
              desc="I am web development enthusiast , which love to work on new technologies like react , node ,express etc. and make usefull projects."
            />
          </Flip>
          {/* <Flip right>
            <ServicesSectionItem
              icon={<IoInfinite />}
              title="DevOps"
              desc="I have knowledge of working with Docker, Kubernetes, Containers using Microsoft Azure. I am AZ-900 Certified. "
            />
          </Flip> */}
        </div>
      </div>
    </ServicesItemStyles>
  );
}

// IoInfinite;
